export default function AumFooter() {
  return (
    <footer className="border-t border-foreground-100/50 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 flex flex-col items-center gap-2 text-center">
        <p className="text-sm text-foreground-500">
          &copy; 2026 AUM1001 Matrix｜宇宙生命樹文明入口｜版權所有
        </p>
        <p className="text-xs text-foreground-400">
          Axion Utopia Matrix（AUM）宇會｜aum1001matrix.org
        </p>
      </div>
    </footer>
  );
}